module.exports = __webpack_public_path__ + "img/spec-dl.e1058a60.png";